import API from '../../../classes/Api/Api'
import URL from '../../../classes/Url/URL';
import CustomError from '../../../classes/CustomError/CustomError';

const FileUploadService = () => {
    
  const uploadFile = async (documentData) => {
    const api = new API(`${URL.URL_SERVER}/documents`);
    
    const formData = new FormData();
    formData.append('file', documentData.file);
    
    if (documentData.id) {
      formData.append('id', documentData.id);
    }
    if (documentData.type) {
      formData.append('type', documentData.type);
    }
    if (documentData.description) {
      formData.append('description', documentData.description);
    }
    
    const http_response = await api.post(formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    const has_error = http_response instanceof CustomError;
    if (has_error) {
      return http_response;
    } else {
      const response = new Response(http_response);
      return response
    }
  };

  return {
    uploadFile
  };
}

export default FileUploadService;